import ImageCard from 'components/cards/base/ImageCard'
import Strings from 'project/localisation'
import { ReactFC } from 'common/types/ReactFC'
import React from 'react'
import { planPerksStrings } from 'common/strings/plan-perks-strings' // we need this to make JSX compile

type PlanPerksCardType = {}

function perks() {
  return [
    {
      description:
        'A fully serviced registered business and directors address.',
      title: 'Prime London Business Address Service.',
    },
    {
      description:
        'We scan and digitise your clients\' mail within 1 working day.  Our system doesn\'t just scan mail — it understands it. We sort and categorise, detect fraud and perform compliance checks.',
      title: 'AI Mail Processing & Document Management.',
    },
    {
      description: 'You determine the ideal price point for your clients.',
      title: 'Set your own margins.',
    },
    {
      description:
        'Our tech-based approach gives you the flexibility to choose how to integrate: whether a simple plug-and-play solution, or a fully white labelled service.  100+ banks, accountancy firms, and businesses trust our virtual office SaaS solutions.',
      title: 'Powerful API & Easy Integration.',
    },
    {
      description:
        'For our plug-and-play service (non-API), our Partner Portal offers a reliable and robust way for our partners to manage their accounts. You can easily manage client accounts, monitor subscriptions, and enjoy a 99.99% system uptime.',
      title: 'Partner Portal.',
    },
    {
      description:
        'Our solution covers everything that an SME would need within a single price plan: a registered office address, mail processing and document management.  To complete the offering we have additional non-core add-ons such as a virtual 020 phone number and the option to have your physical mail forwarded to you.',
      title: 'End-to-End Offering.',
    },
    {
      description:
        "Let us handle the details, including mail management. Whether you prefer API integration or Partner Portal access, you're good to go.",
      title: 'Hassle-Free Operations.',
    },
  ]
}
const PlanPerksCard: ReactFC<PlanPerksCardType> = ({}) => {
  return (
    <ImageCard
      shadow={false}
      reverseColumnsMobile
      verticalAlign='end'
      padding='0'
      imageAlt={`${Strings.companyFormation}`}
      imageLeft
      image='/images/new/cool-robot-holding-phone.png'
      imageDimensions={{
        height: 822,
        width: 604,
      }}
      classNameForCol1='col-12 col-xxxl-6 pe-xxl-14 px-6'
      classNameForCol2='d-bock col-6 offset-3 d-xxxl-block offset-xxxl-0 col-xxxl-6 ps-xxl-5'
    >
      <p className='fw-semibold fs-fluid-24-32 mb-4'>
        {Strings.serviceIncludes}
      </p>
      {perks().map((v) => (
        <>
          <p className='text-large fw-bold mb-2'>{v.title}</p>
          <p
            className='text-large fw-semibold mb-6 text-muted'
            dangerouslySetInnerHTML={{ __html: v.description }}
          />
        </>
      ))}
    </ImageCard>
  )
}

export default PlanPerksCard
